'use client';

import { Sidebar, SidebarContent } from '@mcdougald/ui/src';
import {
  LayoutDashboardIcon,
  MessagesSquareIcon,
  UsersIcon,
} from 'lucide-react';

import { DARK_BACKGROUND_COLOR } from '@/constants/colors';

import AdminNavGroup from './admin-nav-group';

export const ADMIN_SIDEBAR_LINKS = [
  {
    titleKey: 'General',
    links: [
      {
        titleKey: 'Dashboard',
        url: '/admin',
        icon: LayoutDashboardIcon,
      },
      {
        titleKey: 'Users',
        url: '/admin/users',
        icon: UsersIcon,
      },
      {
        titleKey: 'Comments',
        url: '/admin/comments',
        icon: MessagesSquareIcon,
      },
      {
        titleKey: 'Sessions',
        url: '/admin/sessions',
        icon: UsersIcon,
      },
      {
        titleKey: 'Posts',
        url: '/admin/posts',
        icon: UsersIcon,
      },
      {
        titleKey: 'Guestbook',
        url: '/admin/guestbook',
        icon: UsersIcon,
      },
    ],
  },
] as const;

export type SidebarGroup = (typeof ADMIN_SIDEBAR_LINKS)[number];
export type SidebarLink = SidebarGroup['links'][number];

const AdminSidebar = () => {
  return (
    <Sidebar
      collapsible="icon"
      variant="floating"
      className={`bg-[#${DARK_BACKGROUND_COLOR}]`}
    >
      <SidebarContent className={'mt-16'}>
        {ADMIN_SIDEBAR_LINKS.map((group) => (
          // @ts-expect-error - types above work
          <AdminNavGroup key={group.titleKey} {...group} />
        ))}
      </SidebarContent>
    </Sidebar>
  );
};

export default AdminSidebar;
